
export const defaultAnchorOrigin = {
  vertical: 'bottom',
  horizontal: 'center',
};

export const newAnchorOrigin = {
  vertical: 'bottom',
  horizontal: 'right',
};

export const bottomLeftAnchorOrigin = {
  vertical: 'bottom',
  horizontal: 'left',
};

export const centerAnchorOrigin = {
  vertical: 'center',
  horizontal: 'center',
};

export const topLeftAnchorOrigin = {
  vertical: 'top',
  horizontal: 'left',
};

export const defaultTransformOrigin = {
  vertical: 'top',
  horizontal: 'center',
};

export const newTransformOrigin = {
  vertical: 'top',
  horizontal: 'right',
};

export const centerTransformOrigin = {
  vertical: 'center',
  horizontal: 'center',
};